export const canOrderBeResigned = (order) => {
    if (!order?.shipping) {
        return false;
    }
    
    const { status, shipping } = order;
    const validShippingStatuses = ['to_send', 'lms_sent'];

    return status === 'confirmed' 
        && validShippingStatuses.includes(shipping.status) 
        && !shipping.is_label_printed;
};